import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AboutPage from './Pages/AboutUs/AboustUsComponent';
import RegisterAsFarm from './Pages/AboutUs/RegisterAsFarm';
import RegisterAsFarmMain from './Pages/Register_As_FarmMain';
import Goals from './Pages/Home/Goals';
import Funding from './Pages/Funding/Funding';
import BusinessPlans from './Pages/BusinessPlans/BusinessPlans'
import LocationApplication from './Pages/LoanApplication/LocationApplication';
import CreditScore from './Pages/CreditScore/CreditScore';
import TrainingCourse from './Pages/Services/TraningCourse/TraningCourse';

import ProjectPage from './Pages/Project/ProjectPage';
import Registration from './Pages/Registration/Registration';
import TermsAndConditions from './Pages/TermsAndCondition';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import DataPolicy from './Pages/DataPolicy';
import FrequentlyAskedQuestion from './Pages/FrequentlyAskedQuestions';
import Contact from './Pages/Contact';
import Log_in from './Pages/Login/Log_in';
import New_Password from './Pages/Login/New_Password';
import Recover from './Pages/Login/Recover';
import ServicesMain from './Pages/Services/ServicesMain';
import ReportMain from './Pages/Report/ReportMain';
import RegisterOrganization from './Pages/RegisterOrganization';
import SMEChallenges from './components/SMEChallenges';
import BenefitsOfRegistring from './components/BenefitsOfRegistring';

const Root = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => setLoading(false), 1500); // Simulate loading delay
    return () => clearTimeout(timeout);
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="AboutUs" element={<AboutPage />} />
        <Route path="RegisterAsFarm" element={<RegisterAsFarm />} />
        <Route path="RegisterAsFarmMain" element={<RegisterAsFarmMain />} />
        <Route path="Goals" element={<Goals />} />
        <Route path="Funding" element={<Funding />} />
        <Route path="BusinessPlan" element={<BusinessPlans />} />

        <Route path="LocationApplication" element={<LocationApplication />} />
        <Route path="ProjectPage" element={<ProjectPage />} />
        <Route path="Registration" element={<Registration />} />
        <Route path="TermsAndCondition" element={<TermsAndConditions />} />
        <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="DataPolicy" element={<DataPolicy />} />
        <Route path="FrequentlyAskedQuestions" element={<FrequentlyAskedQuestion/>} />
        <Route path="Contact" element={<Contact/>} />
        <Route path="Log_in" element={<Log_in/>} />
        <Route path="New_Password" element={<New_Password/>} />
        <Route path="Recover" element={<Recover/>} />

        <Route path="CreditScore" element={<CreditScore/>} />
        <Route path="Services" element={<ServicesMain/>} />
        <Route path="Report" element={<ReportMain/>} />
        <Route path="TrainingCourse" element={<TrainingCourse/>} />
        <Route path="RegisterOrganization" element={<RegisterOrganization/>} />
        <Route path="SMEChallenges" element={<SMEChallenges/>} />
        <Route path="BenefitsOfRegistring" element={<BenefitsOfRegistring/>} />



      </Routes>
      <Footer />
    </Router>
  );
};


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);

reportWebVitals();
